import { assertNever } from '@kofno/piper';
import { Maybe } from 'maybeasy';
import { action, makeObservable, observable } from 'mobx';
import { PublishingError, PublishingState, error, published, ready } from './Types';
import { LearningCollectionResource } from '../../../../Types';
import { Link } from '../../../../../../Resource/Types';

class PublishingStore {
  @observable
  state: PublishingState;

  constructor(publishLink: Maybe<Link>, publishing: LearningCollectionResource) {
    makeObservable(this);
    this.state = ready(publishing, publishLink);
  }

  @action
  ready = (publishLink: Maybe<Link>, publishing: LearningCollectionResource) => {
    switch (this.state.kind) {
      case 'ready':
      case 'error':
        break;
      case 'waiting':
      case 'publishing':
        this.state = ready(publishing, publishLink);
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  publishing = () => {
    switch (this.state.kind) {
      case 'ready':
        this.state = published(this.state);
        break;
      case 'waiting':
      case 'error':
      case 'publishing':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  error = (err: PublishingError) => {
    switch (this.state.kind) {
      case 'waiting':
        break;
      case 'ready':
      case 'publishing':
        this.state = error(err, this.state);
        break;
      case 'error':
        break;
      default:
        assertNever(this.state);
    }
  };
}

export default PublishingStore;
